/* eslint-disable */

import React from 'react';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';

// components
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';
import permissionLock from '../icons/lock_image_permission.jpg';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function PermissionRestricted() {
  return (
    <RootStyle title="Permission Restricted">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Typography variant="h3" paragraph>
                Permission Restricted
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary' }}>
              You do not have the necessary permissions to access this feature.
            </Typography>

            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src={permissionLock}
                sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 5 } }}
              />
            </motion.div>

            <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
